export const AUTO_DISMISS_DURATION_MS = 1000 * 60 * 3
export const USER_INACTIVITY_TIMEOUT_MS = 1000 * 60 * 120

export type ContinueWatchingModalProps = {
  handleContinueWatchingNavigation: (continueWatching: boolean) => void
}
